/**
 * UI helpers for open QC incident guards. Server routes use `src/qc/quality-incident-guards.ts`;
 * Pre-Encapsulation hard-block copy also lives in `pre-encap-draft-eligibility.ts` — keep aligned.
 */

export interface OpenQualityIncidentDeviceFields {
  hasOpenQualityIncident: boolean;
  openQualityIncidentId: number | null;
  openPottingReworkId?: number | null;
  deviceLabelSerial?: string | null;
  clampSerial?: string | null;
  pcbaSerial?: string | null;
}

function isOpenPottingReworkScan(device: OpenQualityIncidentDeviceFields): boolean {
  const reworkId = device.openPottingReworkId;
  return reworkId != null && reworkId > 0;
}

function incidentLabel(incidentId: number | null | undefined): string {
  return incidentId != null ? ` QC incident #${incidentId}` : " an open QC incident";
}

export function openQualityIncidentStageBlockedMessage(
  device: OpenQualityIncidentDeviceFields,
  stageLabel: string,
): string | null {
  if (!device.hasOpenQualityIncident) {
    return null;
  }
  const serial = device.deviceLabelSerial ?? device.clampSerial ?? "Device";
  const pcbaPart =
    device.pcbaSerial != null && device.pcbaSerial.trim() !== "" ? ` (PCBA ${device.pcbaSerial.trim()})` : "";
  return `STOP — ${serial} cannot move forward at ${stageLabel}.${pcbaPart} Resolve${incidentLabel(device.openQualityIncidentId)} in QC Repair before continuing.`;
}

export function preEncapOpenQualityIncidentBlockMessage(device: OpenQualityIncidentDeviceFields): string | null {
  if (!device.hasOpenQualityIncident || isOpenPottingReworkScan(device)) {
    return null;
  }
  const incidentPart =
    device.openQualityIncidentId != null ? ` QC incident #${device.openQualityIncidentId}` : " QC incident";
  return `STOP — Device has an open${incidentPart}. Send to QC Repair station.`;
}
